export default {
  exportHeader: 'Eksportuj nagłówek',
};
